export default __webpack_public_path__ + "static/media/logo.96ea8e29.png";